<template>
    <section class="page-content settings">
        <div class="wrap btn-position-wrap">
            <div class="row">
                <div class="col-12">
                    <div class="col-4">
                        <button type="button" v-bind:class="{redActiveManual}" @click="changePage('VIDEO')" class="md-button md-raised md-theme-default Usermanual-Tab">
                            <div v-bind:class="{fontManualTab}">
                                Video
                            </div>
                        </button>
                    </div>
                    <div class="col-4">
                        <button @click="changePage('PDF')" v-bind:class="{redActiveManual}" type="button" class="md-button md-raised md-theme-default Usermanual-Tab">
                            <div v-bind:class="{fontManualTab}">
                                Pdf
                            </div>
                        </button>
                    </div>
                    <div class="col-4">
                        <button @click="changePage('FAQ')" v-bind:class="{redActiveManual}" type="button" class="md-button md-raised md-theme-default Usermanual-Tab">
                            <div v-bind:class="{fontManualTab}">
                                FAQ
                            </div>
                        </button>
                    </div>
                </div>
            </div>
            <div class="users-settings-list">
                <div class="row">
                    <div class="col-12">
                        <div v-if="video">
                            <draggable
                                :list="UserManualList"
                                :disabled="!enabled"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                @update="onUpdate"
                                @start="dragging = true"
                                @end="dragging = false"
                                title="Update sequence of support file"
                            >
                                <div v-if="UserManualList.length==0" style="text-align:center">No files found.</div>
                                <div class="item-wrap" v-else v-for="usermanual in UserManualList" :key="usermanual.attachment_name">
                                    <div class="line-item hovered-line list-group-item btn-visible">
                                        <div class="left-item">
                                            <div class="el user-item">
                                                <div class="avatar s-48">
                                                    <md-avatar class="md-avatar-icon">
                                                        <div v-if="usermanual.type === 1">
                                                            <i class="md-icon">picture_as_pdf</i>
                                                        </div>
                                                        <div v-if="usermanual.type === 0">
                                                            <i class="md-icon">videocam</i>
                                                        </div>
                                                        <div v-if="usermanual.type === 2">
                                                            <img class="pencilSelectedfaq" src="static/img/Help_Icon-gr.png">
                                                        </div>
                                                    </md-avatar>
                                                </div>
                                                <h3>{{ usermanual.attachment_name.substring(0, 35) }} <small></small></h3>
                                            </div>
                                            <div class="el email-item">
                                                <a class="email-link">{{ usermanual.path.substring(0, 75) }}</a>
                                            </div>
                                        </div>
                                        <div class="right-item">
                                            <div v-if="isAdmin">
                                                <div class="el admin-check">
                                                </div>
                                                <md-button title="Edit Link" class="md-icon-button" @click="showCurrentUserManual(usermanual)">
                                                    <md-icon>mode_edit</md-icon>
                                                </md-button>
                                                <md-button title="Delete" class="md-icon-button" @click="confirmDelete(usermanual)">
                                                    <md-icon>delete</md-icon>
                                                </md-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </draggable>
                        </div>
                        <div v-else-if="faq">
                          <draggable
                                :list="UserManualListfaq"
                                :disabled="!enabled"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                @update="onUpdate"
                                @start="dragging = true"
                                @end="dragging = false"
                                title="Update sequence of support file"
                            >
                                <div v-if="getUserManualListfaq.length==0" style="text-align:center">No files found.</div>
                                <div class="item-wrap" v-else v-for="(usermanual, index) in getUserManualListfaq" :key="index">
                                    <div class="line-item hovered-line list-group-item btn-visible">
                                      <div class="left-item">
                                        <div class="el user-item question">
                                            <div class="avatar avatar2 s-48">
                                                <md-avatar class="md-avatar-icon">
                                                    <img src="static/img/Help_Icon-gr.png">
                                                </md-avatar>
                                            </div>
                                            <h3>{{ usermanual.question }} <small></small></h3>
                                        </div>
                                        <div class="el email-item">
                                            <h3>{{ usermanual.answers }} <small></small></h3>
                                        </div>
                                      </div>
                                      <div class="right-item">
                                        <div v-if="isAdmin">
                                            <div class="el admin-check">
                                            </div>
                                            <md-button title="Edit Link" class="md-icon-button" @click="showCurrentUserManualfaq(usermanual)">
                                                <md-icon>mode_edit</md-icon>
                                            </md-button>
                                            <md-button title="Delete" class="md-icon-button" @click="confirmDeletefaq(usermanual)">
                                                <md-icon>delete</md-icon>
                                            </md-button>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </draggable>
                        </div>
                        <div v-else>
                            <draggable
                                :list="UserManualList"
                                :disabled="!enabled"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                @update="onUpdate"
                                @start="dragging = true"
                                @end="dragging = false"
                                title="Update sequence of support file"
                            >
                                <div v-if="UserManualList.length==0" style="text-align:center">No files found.</div>
                                <div v-else class="item-wrap" v-for="usermanual in UserManualList" :key="usermanual.attachment_name">
                                    <div class="line-item hovered-line list-group-item btn-visible">
                                        <div class="left-item">
                                            <div class="el user-item">
                                                <div class="avatar s-48">
                                                    <md-avatar class="md-avatar-icon">
                                                        <div v-if="usermanual.type">
                                                            <i class="md-icon">picture_as_pdf</i>
                                                        </div>
                                                        <div v-else>
                                                            <i class="md-icon">videocam</i>
                                                        </div>
                                                    </md-avatar>
                                                </div>
                                                <h3>{{ usermanual.attachment_name.substring(0, 35) }} <small></small></h3>
                                            </div>
                                            <div class="el email-item">
                                                <a class="email-link">{{ usermanual.path.substring(0, 75) }}</a>
                                            </div>
                                        </div>
                                        <div class="right-item">
                                            <div v-if="isAdmin">
                                                <div class="el admin-check">
                                                </div>
                                                <md-button title="Edit Link" class="md-icon-button" @click="showCurrentUserManual(usermanual)">
                                                    <md-icon>mode_edit</md-icon>
                                                </md-button>
                                                <md-button title="Delete" class="md-icon-button" @click="confirmDelete(usermanual)">
                                                    <md-icon>delete</md-icon>
                                                </md-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </draggable>
                        </div>
                    </div>
                </div>
                <!---Add More UserManual Link -->
                <div class="bottom-btn-position">
                    <div class="wrap" v-if="showVideoPdf && !showfaq">
                        <md-button @click="clickAddNewManual()" class="add-tour-button md-fab md-accent md-primary">
                            <md-icon>add</md-icon>
                        </md-button>
                    </div>
                    <div class="wrap" v-if="!showVideoPdf && showfaq">
                        <md-button @click="clickAddNewManualtext()" class="add-tour-button md-fab md-accent md-primary">
                            <md-icon>add</md-icon>
                        </md-button>
                    </div>
                </div>
                <!---End of Add More UserManual Link -->
            </div>
        </div>
        <!---End of Add More UserManual Link -->
        <!--Confirmation box to delete manual -->
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialog">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Are you sure you want to delete <b>{{ userManualDelete.attachment_name }}</b>? This action cannot be undone.
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="remove(userManualDelete.id)">DELETE</md-button>
                <md-button class="ManualBtn ManualBtncancel" @click="closeDialog()">CANCEL</md-button>
            </md-dialog-actions>
        </md-dialog>
        <!--End of Confirmation box to delete manual -->

        <!--Confirmation box to delete manual faq -->
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialogfaq">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Are you sure you want to delete <b>{{ userManualDeletefaq.question }}</b>? This action cannot be undone and also delete Answer.
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="removes(userManualDeletefaq.id)">Delete</md-button>
                <md-button class="ManualBtn ManualBtncancel" @click="closeDialogtext()">Cancel</md-button>
            </md-dialog-actions>
        </md-dialog>
        <!--End of Confirmation box to delete manual -->

        <!-- Edit model pop-up-->
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showEditDialog" style="height:70%" width="70%">
            <md-dialog-title>
                Update Support
            </md-dialog-title>
            <p v-if="responseProcess" style="padding: 24px 24px 0; color:green;">{{ this.responseProcess }}</p>
            <p v-if="errors" style="padding: 24px 24px 0; color:red;">{{ this.errors }}</p>
            <md-dialog-content>
                <div class="md-field md-block md-theme-default md-has-placeholder">
                    <input type="text" v-model="attachmentname" placeholder="File Name" class="md-input">
                </div>
                <div class="md-field md-block md-theme-default md-has-placeholder">
                    <input type="file" id="files" ref="files" v-on:change="handleFiles()" class="remove-no-file-chosen"/>
                    <span class="showSelectedFile">{{ this.shownamefile }}</span>
                </div>
                <p class="info-manual"><b>Note:</b> Please select file with extension mp4, ogv, webm and pdf</p>
            </md-dialog-content>
            <md-dialog-actions class="full-btn">

                <md-button class="ManualBtn" style="background-color: #00a8ca !important;" @click="updateUsermnual(userManualEdit.id)">Update</md-button>
                <md-button class="ManualBtn" style="color: black !important; background-color: white !important; border-color: #ccc !important;" @click="closeDialog()">Cancel</md-button>
            </md-dialog-actions>
        </md-dialog>
        <!--Edit model pop-up-->
        <!-- Edit model pop-up faq-->
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showEditDialogfaq" style="height:75%;overflow: auto;" width="70%">
            <md-dialog-title>
                Update Support
            </md-dialog-title>
            <p v-if="errors" style="padding: 24px 24px 0; color:red;">{{ this.errors }}</p>
            <p v-if="responseProcess" style="padding: 24px 24px 0; color:green;">{{ this.responseProcess }}</p>
            <md-dialog-content>
                <div>
                    <textarea v-model="question" maxlength="250" placeholder="Enter Question" cols="300" rows="10" class="md-textarea"></textarea>
                </div>
                <br>
                <div>
                    <textarea v-model="answers" maxlength="400" placeholder="Enter Answer" id="question" cols="30" rows="10" class="md-textareaa"></textarea>
                </div>
                <br>
                <p><b>Note:</b> These are text only fields</p>
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn" style="background-color: #00a8ca !important;" @click="updateUsermnualfaq(userManualEditfaq.id)">Update</md-button>
                <md-button class="ManualBtn" style="color: black !important; background-color: white !important; border-color: #ccc !important;" @click="closeDialogtext()">Cancel</md-button>
            </md-dialog-actions>
        </md-dialog>
        <!--Edit model pop-up-->

        <!-- Add model pop-up-->
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showAddDialog" v-if="showVideoPdf && !showfaq">
            <md-dialog-title>
                Add Support
            </md-dialog-title>
            <p v-if="errors" style="padding: 24px 24px 0; color:red;">{{ this.errors }}</p>
            <p v-if="responseProcess" style="padding: 24px 24px 0; color:green;">{{ this.responseProcess }}</p>
            <md-dialog-content style="height:200%">
                <div class="md-field md-block md-theme-default md-has-placeholder">
                    <input type="text" v-model="attachmentname" placeholder="File Name" class="md-input">
                </div>
                <div class="md-field md-block md-theme-default md-has-placeholder">
                    <input type="file" id="files" ref="files" v-on:change="handleFiles()" class="remove-no-file-chosen">
                    <span class="showSelectedFile">{{ this.shownamefile }}</span>
                </div>
                <p class="info-manual"><b>Note:</b> Please select file with extension mp4, ogv, webm and pdf</p>
            </md-dialog-content>
            <md-dialog-actions class="full-btn" v-if="showVideoPdf && !showfaq">
                <md-button class="ManualBtn" style="background-color: #00a8ca !important;" @click="saveUsermnual()">Save</md-button>
                <md-button class="ManualBtn" style="color: black !important; background-color: white !important; border-color: #ccc !important;" @click="closeDialog()">Cancel</md-button>
            </md-dialog-actions>
        </md-dialog>
        <!--Add model pop-up-->

        <!-- Add model pop-up-->
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showAddDialog" v-if="showVideoPdf && !showfaq">
            <md-dialog-title>
                Add Support
            </md-dialog-title>
            <p v-if="errors" style="padding: 24px 24px 0; color:red;">{{ this.errors }}</p>
            <p v-if="responseProcess" style="padding: 24px 24px 0; color:green;">{{ this.responseProcess }}</p>
            <md-dialog-content style="height:200%">
                <div class="md-field md-block md-theme-default md-has-placeholder">
                    <input type="text" v-model="attachmentname" placeholder="File Name" class="md-input">
                </div>
                <div class="md-field md-block md-theme-default md-has-placeholder">
                    <input type="file" id="files" ref="files" v-on:change="handleFiles()" class="remove-no-file-chosen">
                    <span class="showSelectedFile">{{ this.shownamefile }}</span>
                </div>
                <p class="info-manual"><b>Note:</b> Please select file with extension mp4, ogv, webm and pdf</p>
            </md-dialog-content>
            <md-dialog-actions class="full-btn" v-if="showVideoPdf && !showfaq">
                <md-button class="ManualBtn" style="background-color: #00a8ca !important;" @click="saveUsermnual()">Save</md-button>
                <md-button class="ManualBtn" style="color: black !important; background-color: white !important; border-color: #ccc !important;" @click="closeDialog()">Cancel</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showAddDialogtext" v-if="showfaq && !showVideoPdf" style="height:75%" width="70%">
            <md-dialog-title>
                Add Support
            </md-dialog-title>
            <p v-if="errors" style="padding: 24px 24px 0; color:red;">{{ this.errors }}</p>
            <p v-if="responseProcess" style="padding: 24px 24px 0; color:green;">{{ this.responseProcess }}</p>
            <md-dialog-content>
                <div>
                    <textarea v-model="question" maxlength="250" placeholder="Enter Question" cols="300" rows="10" class="md-textarea" required></textarea>
                </div>
                <br>
                <div>
                    <textarea v-model="answers" maxlength="400" placeholder="Enter Answer" id="question" cols="30" rows="10" class="md-textareaa" required></textarea>
                </div>
                <br>
                <p style="margin-bottom:-220px"><b>Note:</b> These are text only fields</p>
            </md-dialog-content>
            <md-dialog-actions class="full-btn" v-if="showfaq && !showVideoPdf">
                <md-button class="ManualBtn" style="background-color: #00a8ca !important; margin-top:-10px;" @click="saveUsermnualtext()">Save</md-button>
                <md-button class="ManualBtn" style="margin-top:-10px; color: black !important; background-color: white !important; border-color: #ccc !important;" @click="closeDialogtext()">Cancel</md-button>
            </md-dialog-actions>
        </md-dialog>
        <!--Add model pop-up for text-->
    </section>
</template>

<script>
import draggable from 'vuedraggable';
import {mapGetters} from 'vuex';
import axios from 'axios';
import {getUserManualVideo, getUserManualfaq, deleteUsermanual, deleteUsermanualfaq, getUserManualPdf, updateUsermnualList} from '../../services/ClientService.js';

export default {
  components: {
    draggable
  },
  data: () => ({
    shownamefile: '',
    responseProcess: '',
    video: true,
    pdf: false,
    faq: false,
    errors: '',
    files: '',
    attachmentname: '',
    question: '',
    answers: '',
    showDeleteDialog: false,
    showEditDialog: false,
    showDeleteDialogfaq: false,
    showEditDialogfaq: false,
    showAddDialog: false,
    showAddDialogtext: false,
    showVideoPdf: true,
    showfaq: false,
    defaultTriSet: {},
    formError: false,
    userManualDelete: [],
    userManualEditfaq: [],
    userManualDeletefaq: [],
    userManualEdit: [],
    enabled: true,
    UserManualList: [{
      id: '',
      attachment_name: '',
      type: '',
      path: '',
      priority: ''
    }],
    UserManualListfaq: [{
      id: '',
      attachment_name: '',
      question: '',
      answers: '',
      type: ''
    }],
    getUserManualListfaq: [],
    dragging: false
  }),
  computed: {
    ...mapGetters('client', ['clientActive', 'currentClient']),
    ...mapGetters('user', ['userList', 'isAdmin', 'currentUser'])
  },
  methods: {
    checkMove: function (e) {
      window.console.log('Future index: ' + e.draggedContext.futureIndex);
    },
    onUpdate () {
      this.$emit('updated', this.UserManualList);
      this.saveUserManualOrder();
    },
    async saveUserManualOrder () {
      let result = await updateUsermnualList(this.UserManualList);
      return result;
    },
    changePage (page) {
      if (page === 'VIDEO') {
        this.showVideoPdf = true;
        this.showfaq = false;
        // if (this.video === false) {
        //   this.isActive = !this.isActive;
        // }
        this.video = true;
        this.pdf = false;
        this.faq = false;
      }
      if (page === 'PDF') {
        this.showVideoPdf = true;
        this.showfaq = false;
        // if (!this.pdf === false) {
        //   this.isActive = !this.isActive;
        // }
        this.pdf = true;
        this.video = false;
        this.faq = false;
      }
      if (page === 'FAQ') {
        this.showVideoPdf = false;
        this.showfaq = true;
        // if (!this.faq === false) {
        //   this.isActive = !this.isActive;
        // }
        this.faq = true;
        this.pdf = false;
        this.video = false;
      }
      this.loadUserManual();
    },
    clickAddNewManual () {
      this.showAddDialog = true;
    },
    clickAddNewManualtext () {
      this.showAddDialogtext = true;
    },
    confirmDelete (usermanual) {
      this.showDeleteDialog = true;
      this.userManualDelete = usermanual;
    },
    confirmDeletefaq (usermanual) {
      this.showDeleteDialogfaq = true;
      this.userManualDeletefaq = usermanual;
    },
    closeDialog () {
      this.shownamefile = '';
      this.files = '';
      this.attachmentname = '';
      this.showDeleteDialog = false;
      this.showEditDialog = false;
      this.showAddDialog = false;
      this.showAddDialogtext = false;
      this.usermanualIdToDelete = null;
      this.userManualDelete = [];
      this.userManualEdit = [];
      this.errors = '';
      this.responseProcess = '';
    },
    closeDialogtext () {
      this.shownamefile = '';
      this.files = '';
      this.attachmentname = '';
      this.question = '';
      this.answers = '';
      this.showDeleteDialogfaq = false;
      this.showEditDialogfaq = false;
      this.showAddDialog = false;
      this.showAddDialogtext = false;
      this.usermanualIdToDeletefaq = null;
      this.userManualDeletefaq = [];
      this.userManualEdit = [];
      this.errors = '';
      this.responseProcess = '';
    },
    async remove (id) {
      await deleteUsermanual(id);
      var result = await getUserManualVideo();
      this.UserManualList = result.data;
      this.showDeleteDialog = false;
      this.usermanualIdToDelete = null;
      this.userManualDelete = [];
      this.loadUserManual();
    },
    async removes (id) {
      await deleteUsermanualfaq(id);
      var result = await getUserManualfaq();
      this.UserManualListfaq = result.data;
      this.showDeleteDialogfaq = false;
      this.usermanualIdToDeletefaq = null;
      this.userManualDeletefaq = [];
      this.loadUserManual();
    },
    showCurrentUserManual (usermanual) {
      this.showEditDialog = true;
      this.userManualEdit = usermanual;
      this.attachmentname = usermanual.attachment_name;
    },
    showCurrentUserManualfaq (usermanual) {
      this.showEditDialogfaq = true;
      this.userManualEditfaq = usermanual;
      this.question = usermanual.question;
      this.answers = usermanual.answers;
    },
    async loadUserManual () {
      var result = '';
      if (this.video) {
        result = await getUserManualVideo();
      } else if (this.pdf) {
        result = await getUserManualPdf();
      } else if (this.faq) {
        result = await getUserManualfaq();
        this.getUserManualListfaq = result.data;
      }
      this.UserManualList = result.data;
    },
    handleFiles () {
      this.shownamefile = '';
      let uploadedFiles = this.$refs.files.files;
      this.files = uploadedFiles[0];
      this.shownamefile = this.files.name;
    },
    async saveUsermnual () {
      this.responseProcess = 'Uploading Files...';
      this.errors = '';
      let formData = new FormData();
      formData.append('attachmentname', this.attachmentname);
      formData.append('file', this.files);
      formData.append('created', this.currentUser.id);
      axios.post('api/client/createUsermanual',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        if (response.data !== 'success') {
          this.errors = response.data;
          this.responseProcess = '';
          this.shownamefile = '';
        } else {
          this.errors = '';
          this.files = '';
          this.attachmentname = '';
          this.loadUserManual();
          this.showAddDialog = false;
          this.responseProcess = '';
          this.shownamefile = '';
        }
      }).catch(function () {
        console.log('FAILURE!!');
      });
    },
    async saveUsermnualtext () {
      this.errors = '';
      let formDatatext = new FormData();
      formDatatext.append('question', this.question);
      formDatatext.append('answers', this.answers);
      axios.post('api/client/createUsermanualfaq',
        formDatatext,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        if (response.data !== 'success') {
          this.errors = response.data;
          this.responseProcess = '';
          this.shownamefile = '';
          this.showAddDialogtext = true;
          this.question = '';
          this.answers = '';
        } else {
          this.errors = '';
          this.files = '';
          this.attachmentname = '';
          this.loadUserManual();
          this.showAddDialogtext = false;
          this.responseProcess = '';
          this.shownamefile = '';
          this.question = '';
          this.answers = '';
        }
      }).catch(function () {
        console.log('FAILURE!!');
      });
    },
    async updateUsermnual (id) {
      this.responseProcess = 'Uploading Files...';
      let formData = new FormData();
      formData.append('attachmentname', this.attachmentname);
      formData.append('file', this.files);
      formData.append('usermanual_id', id);
      formData.append('created', this.currentUser.id);
      axios.post('api/client/updateUsermanual',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        if (response.data !== 'success') {
          this.errors = response.data;
          this.responseProcess = '';
          this.shownamefile = '';
          this.showAddDialogtext = true;
        } else {
          this.showAddDialogtext = false;
          this.responseProcess = '';
          this.errors = '';
          this.files = '';
          this.attachmentname = '';
          id = '';
          this.loadUserManual();
          this.showEditDialog = false;
          this.shownamefile = '';
        }
      }).catch(function () {
        console.log('FAILURE!!');
      });
    },
    async updateUsermnualfaq (id) {
      let formData = new FormData();
      formData.append('question', this.question);
      formData.append('answers', this.answers);
      formData.append('usermanual_id', id);
      axios.post('api/client/updateUsermanualfaq', formData).then(response => {
        if (response.data !== 'success') {
          this.errors = response.data;
          this.responseProcess = '';
          this.question = '';
          this.answers = '';
          this.showEditDialogfaq = false;
          this.loadUserManual();
        } else {
          this.responseProcess = '';
          this.errors = '';
          this.question = '';
          this.answers = '';
          id = '';
          this.showEditDialogfaq = false;
          this.loadUserManual();
        }
      }).catch(function () {
        console.log('FAILURE!!');
      });
    }
  },
  mounted () {
    this.loadUserManual();
  }
};
</script>

<style lang="scss" scoped>
.bottom-btn-position {
    position: fixed !important;
    right: 12px !important;
    bottom: 32px !important;
    width: 500px;
    padding-right: 35px;

    button {
        z-index: 15;
    }
}

.wrap {
    padding-top: 0 !important;
}

.hovered-line:hover {
    background-color: rgba(0, 0, 0, 0.2);
}

.user-item {
    cursor: pointer;
}

.container {
    padding: 0 64px;
    max-width: 1366px;
    margin: 0 auto;
}

.users-settings-list {
    padding: 32px;
}

.Usermanual-Tab {
    background-color: rgb(0, 168, 202);
    width: 100%;
    height: 39px;
}

.redActiveManual {
    border-bottom: 2px solid #08a8ca;

}

.fontManualTab {
    color: #08a8ca;
}

input.remove-no-file-chosen {
    width: 90px;
    color: #fff;
}

.showSelectedFile {
    padding-left: 0px !important;
    padding-top: 5px;
}

.full-btn {
    padding-right: 20px !important;
    padding-left: 10px !important;
}

.ManualBtn {
    display: inline-block !important;
    margin-bottom: 0 !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    -ms-touch-action: manipulation !important;
    touch-action: manipulation !important;
    cursor: pointer !important;
    background-image: none !important;
    border: 1px solid transparent !important;
    padding: 6px 12px !important;
    font-size: 14px !important;
    line-height: 1.42857143 !important;
    border-radius: 4px !important;
    color: #fff !important;
}

.info-manual {
    font-size: 12px;
    margin-top: -20px;
    margin-bottom: -30px;
    overflow: hidden;
}

.md-field .md-input, .md-field {
    width: 100%;
    height: 32px;
    padding: 0;
    display: block;
    -webkit-box-flex: 1;
    flex: 1;
    border: none;
    background: none;
    transition: .4s cubic-bezier(.25, .8, .25, 1);
    transition-property: font-size, padding-top, color;
    font-family: inherit;
    font-size: 12px;
    line-height: 32px;
}

.md-textarea {
    width: 100%;
    height: 140px;
    padding: 5px;
    display: block;
    -webkit-box-flex: 1;
    flex: 1;
    border: 1px;
    border-bottom-style: solid;
    background: none;
    transition: .4s cubic-bezier(.25, .8, .25, 1);
    transition-property: font-size, padding-top, color;
    font-family: inherit;
    font-size: 15px;
    line-height: 32px;
}

.md-textareaa {
    width: 100%;
    height: 230px;
    padding: 5px;
    display: block;
    -webkit-box-flex: 1;
    flex: 1;
    border: 1px;
    border-bottom-style: solid;
    background: none;
    transition: .4s cubic-bezier(.25, .8, .25, 1);
    transition-property: font-size, padding-top, color;
    font-family: inherit;
    font-size: 15px;
    line-height: 32px;
}


.ManualBtndelete {
    background-color: #d9534f !important;
}

.ManualBtncancel {
    color: white !important;
    background-color: #00a8ca !important;
    border-color: #ccc !important;
}

.item-wrap .question {

    min-width: 100%;
    width: 100%;
    max-width: 100%;
    margin-bottom: 10px;
    display: flex;
    // padding-left: 30px;
}

.users-settings-list .line-item .avatar2 {
    float: left;
    margin-right: 16px;
    position: absolute;
    left: -1px;
}

@media only screen and (max-width: 1024px) {
    .users-settings-list .line-item {
        display: flex;
        flex-flow: row nowrap;
    }

    .users-settings-list .line-item .left-item {
        display: flex;
    }
}

@media only screen and (max-width: 768px) {
    .users-settings-list .line-item .left-item {
        flex-flow: row wrap;
    }
    .el.email-item {
        padding-left: 10px;
    }
}

button.md-button.ManualBtn.ManualBtndelete.md-theme-default span.md-button-content {
    font-size: 15px;
}

button.md-button.ManualBtn.ManualBtncancel.md-theme-default span.md-button-content {
    font-size: 15px;
}

.users-settings-list .line-item {
    padding: 16px 20px 16px 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/UsermanualSettings.vue